import React from 'react';
import { getShowCount } from '@op/utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useIntl } from 'umi';
import './index.scss';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';

export default function SteamLineReviews({
  steamRenderReviewList,
  reviewTotal,
  formatNumber = getShowCount,
  showReviewTotal = true,
}: any) {
  const { formatMessage } = useIntl();
  return (
    <div className="steam-line-reviews-wrapper">
      {showReviewTotal && (
        <div className="context-item-num">
          {formatNumber(reviewTotal)} {formatMessage({ id: 'Reviews' })}
        </div>
      )}
      {steamRenderReviewList.map(
        ({ color, text, width, value, icon, tipsMap = null }: any) => (
          <div className="context-item-goodNum" key={text}>
            <SvgIcon type={icon} className="context-item-goodNum-icon" />
            <BubbleCommon placement="top" tipsMap={tipsMap} showIcon={false}>
              <span className="context-item-goodNum-desc">
                {formatMessage({ id: text })}
              </span>
            </BubbleCommon>
            <div
              className="context-item-goodNum-line"
              style={{ width: width, background: color }}
            />
            <span className="context-item-goodNum-text">
              {getShowCount(value)} ({width})
            </span>
          </div>
        ),
      )}
    </div>
  );
}
